import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/suppliers'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'suppliers'

export const metadata = {
  icon: 'truck',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const SuppliersListPage = createListPage({ metadata, api, actionCreators, Content })
const SuppliersDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { SuppliersListPage, SuppliersDetailPage }

